import axios from "axios";

// TODO: 에러형식까지 반환하는 형태로 만들기 admin에서의 형식
export const createTeeshotAxiosInstance = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_TEESHOT_SERVER_URL,
    timeout: 10000,
    headers: {
      Authorization: (() => {
        const token = localStorage.getItem("auth-token");
        return `Bearer ${token}`;
      })(),
    },
  });
};
